import React, { useState } from "react";
import { getFirestore, collection, addDoc, Timestamp } from "firebase/firestore";
import { app } from "../../../firebase";

const FolderCreateModal = ({ parentId, onClose, onCreated }) => {
  const [name, setName] = useState("");
  const [creating, setCreating] = useState(false);
  const db = getFirestore(app);

  const handleCreate = async () => {
    if (!name.trim()) return;
    setCreating(true);
    const now = Timestamp.now();
    const docRef = await addDoc(collection(db, "folderStructures"), {
      name,
      parentId: parentId || null,
      createdAt: now,
      updatedAt: now,
      modifiedAt: now,
      locked: false,
    });
    setCreating(false);
    onCreated(docRef.id); // Pass new folder id to parent
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white p-8 rounded-2xl shadow-2xl w-full max-w-lg relative animate-fadeIn">
        <button className="absolute top-3 right-3 text-gray-400 hover:text-blue-600 text-xl" onClick={onClose} disabled={creating}>&times;</button>
        <h3 className="text-2xl font-extrabold text-blue-700 mb-6 text-center">Create New Folder</h3>
        <input
          type="text"
          value={name}
          onChange={e => setName(e.target.value)}
          placeholder="Folder name"
          className="w-full mb-6 px-3 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-200"
          disabled={creating}
        />
        {creating && (
          <div className="flex flex-col items-center mb-4">
            <svg className="animate-spin h-8 w-8 text-blue-600 mb-2" viewBox="0 0 24 24" fill="none"><circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle><path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"></path></svg>
            <div className="text-blue-700 font-semibold">Creating folder...</div>
          </div>
        )}
        <div className="flex justify-end space-x-2 mt-6">
          <button className="px-4 py-2 bg-gray-200 rounded-lg font-semibold" onClick={onClose} disabled={creating}>Cancel</button>
          <button className="px-4 py-2 bg-[#0071bd] text-white rounded-lg font-semibold shadow hover:bg-[#005fa3] transition" onClick={handleCreate} disabled={creating || !name.trim()}>
            {creating ? "Creating..." : "Create"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default FolderCreateModal;
